import { render, staticRenderFns } from "./DashboardSimplePanel.vue?vue&type=template&id=3918c3a2&scoped=true&"
import script from "./DashboardSimplePanel.vue?vue&type=script&lang=ts&"
export * from "./DashboardSimplePanel.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSimplePanel.vue?vue&type=style&index=0&id=3918c3a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918c3a2",
  null
  
)

export default component.exports